import type { GetPinterestAdAccountsAction } from './getAdAccounts.action';
import type { GetPinterestAuthenticationUrlAction } from './getAuthenticationUrl.action';
import type { GetSanAdAccountZeitStatusAction } from '../../actions/getSANAdPartnerZeitStatus';

export * from './getAdAccounts.action';
export * from './getAuthenticationUrl.action';

export type PinterestAction =
  | GetPinterestAdAccountsAction
  | GetPinterestAuthenticationUrlAction
  | GetSanAdAccountZeitStatusAction;
